<template>
  <div class="home">
    <div class="middle min-container">
      <div class="container">
        <div class="report_con">
          <div class="left center">
            <div class="left_item bg-color highlight">
              {{ $t('common.p24') }}
            </div>
            <div
              class="left_item bg-color home-p-color"
              @click="toBrand"
            >
              <p>{{ $t('common.p25') }}</p>
            </div>
          </div>
          <div class="right bg-color home-p-color">
            <h2 class="title home-color">
              {{ $t('about.p2') }}
            </h2>
            <p>{{ $t('about.p3') }}</p>
            <p>{{ $t('about.p4') }}</p>
            <p>{{ $t('about.p5') }}</p>
            <h2
              class="title home-color"
              style="margin-top: 40px;"
            >
              {{ $t('about.p6') }}
            </h2>
            <p>{{ $t('about.p7') }}</p>
            <i18n
              path="about.p8"
              tag="p"
            >
              <a
                class="home-color"
                place="link"
                href="mailto:info@pppoker.net"
              >info@pppoker.net</a>
            </i18n>
            <p>{{ $t('about.p9') }}</p>
            <i18n
              path="about.p8"
              tag="p"
            >
              <a
                class="home-color"
                place="link"
                href="mailto:branding@pppoker.net"
              >branding@pppoker.net</a>
            </i18n>
            <p>For Public Relationship Enquiry:</p>
            <i18n
              path="about.p8"
              tag="p"
            >
              <a
                class="home-color"
                place="link"
                href="mailto:pr@pppoker.net"
              >pr@pppoker.net</a>
            </i18n>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
    }
  },
  created () {
    this.$store.commit('changeTab', '/home')
  },
  mounted () {
    document
      .querySelector('#app')
      .scrollIntoView({ block: 'start', behavior: 'smooth' })
  },
  methods: {
    toBrand () {
      this.$router.push({ name: 'brand' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  padding: 65px 0px 65px 0px;
  min-width: 1200px;
  .middle {
    position: relative;
    // background-color: #2a2a2a;
    padding: 0px;
    .report_con {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      .left {
        position: relative;
        display: inline-block;
        width: 224px;
        .left_item {
          width: 220px;
          height: 55px;
          margin-bottom: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          p {
            max-width:100%
          }
          .p1 {
            font-size: 14px;
            text-align: left;
          }
          .p2 {
            font-size: 12px;
            color: #7b7b7b;
            text-align: right;
          }
        }
        .highlight {
          background-color: #58b26d;
        }
      }
      .right {
        position: relative;
        width: 868px;
        display: inline-block;
        padding: 52px 44px;
        .title {
          font-size: 32px;
          margin: 0px 0px 20px 0px;
        }
        p {
          font-size: 16px;
          margin: 15px 0px;
          line-height: 24px;
        }
      }
    }
  }
}
</style>
